"use strict";

define(['jquery', './base', 'libs/helpers/screen-sizes'], function ($, BaseHelper, screenSizes) {
  return BaseHelper.extend({
    ui: {
      content: '.js-collapsable--content',
      trigger: '.js-collapsable--trigger'
    },
    options: {
      animateSelector: '[data-animate]',
      animationSpeed: 200,
      hiddenClass: 'is-hidden',
      activeClass: 'is-active',
      scrollTo: false
    },
    events: {
      change: 'bindUIElements',
      'click @ui.trigger': 'toggleContent'
    },
    scrollToContainer: function scrollToContainer($el, isScrollable) {
      if (!isScrollable) return false;
      if (!screenSizes.isLessThanMedium()) return false;
      $('body,html').animate({
        scrollTop: $el.parent().offset().top
      }, this.options.animationSpeed);
    },
    toggleContent: function toggleContent(e) {
      if (e.target.classList.contains('js-phrase')) {
        return;
      }

      e.preventDefault();
      var $el = $(e.currentTarget);
      var toggle = $el.data('toggle');
      var show = $el.data('show');
      var hide = $el.data('hide');
      var content = toggle || show || hide || false;
      var $content = this.ui.content.filter('[data-collapse="' + content + '"]');
      var accordionGroup = $content.data('accordion');
      var hiddenClass = $content.data('hidden') || this.options.hiddenClass;
      var animateSelector = this.options.animateSelector;
      var animationSpeed = this.options.animationSpeed;
      var activeClass = this.options.activeClass;
      var scrollto = $content.data('scrollto') || this.options.scrollTo; // Check if another trigger needs active state removed

      this.ui.trigger.each(function () {
        if (this !== $el.context) {
          $(this).removeClass(activeClass);
        }
      });

      if (accordionGroup) {
        // Make sure we remove the selected element
        var group = this.ui.content.filter('[data-accordion="' + accordionGroup + '"]').not($content);
        group.filter(animateSelector).slideUp(animationSpeed);
        group.not(animateSelector).addClass(hiddenClass).removeClass(activeClass);
      }

      if (toggle) {
        $content.toggleClass(hiddenClass);
        $el.toggleClass(activeClass);
      } else {
        if (show) {
          $content.filter('[data-animate]').slideDown(animationSpeed, this.scrollToContainer.bind(this, $el, scrollto));
        } else {
          $content.filter('[data-animate]').slideUp(animationSpeed);
        }

        $content.not('[data-animate]').toggleClass(hiddenClass, !show);
        this.ui.trigger.removeClass(activeClass);
        $el.toggleClass(activeClass, !!show);
      }

      return false;
    }
  });
});